import React from 'react';

const Footer: React.FC = () => {
  const scrollToSection = (sectionId: string) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer className="site-footer">
      <div className="container">
        <div className="footer-content">
          <div className="footer-brand">
            <h3>AskEko</h3>
            <p>La 1ère application du réemploi, associée à un programme de "CashBack Planet" qui récompense les émissions de CO² évitées.</p>
            <div className="footer-apps">
              <h4>Télécharger l'application</h4>
              <div className="footer-badges">
                <a href="https://apps.apple.com/fr/app/askeko/id6747683571" target="_blank" rel="noopener noreferrer" aria-label="Télécharger dans l'App Store">
                  <img src="/badges/app-store-badge-fr.svg" alt="Télécharger dans l'App Store" />
                </a>
                <a href="https://play.google.com/store/apps/details?id=com.deltri.frontapp.live" target="_blank" rel="noopener noreferrer" aria-label="Disponible sur Google Play">
                  <img src="/badges/google-play-badge-fr.png" alt="Disponible sur Google Play" />
                </a>
              </div>
              <div className="footer-qr">
                <img src="/badges/qr-app.svg" alt="QR code pour télécharger l'application AskEko" />
                <span>Scannez pour télécharger</span>
              </div>
            </div>
          </div>

          <div className="footer-section">
            <h4>Liens rapides</h4>
            <ul className="footer-menu">
              <li><a href="#benefits" onClick={(e) => { e.preventDefault(); scrollToSection('benefits'); }}>Avantages</a></li>
              <li><a href="#how-it-works" onClick={(e) => { e.preventDefault(); scrollToSection('how-it-works'); }}>Fonctionnement</a></li>
              <li><a href="#contact" onClick={(e) => { e.preventDefault(); scrollToSection('contact'); }}>Contact</a></li>
            </ul>
          </div>

          <div className="footer-section">
            <h4>Contact</h4>
            <div className="footer-contact">
              <p>Immeuble PARK PLAZA 2 – HUB INNOVATION</p>
              <p>Parc Scientifique de la Haute Borne</p>
              <p>11-B avenue de l'Harmonie</p>
              <p>59650 VILLENEUVE D'ASCQ</p>
            </div>
          </div>
        </div>

        <div className="footer-bottom">
          <div className="footer-copyright">
            <p>2025 DELTRI - AskEko. Tous droits réservés.</p>
          </div>
          <div className="footer-social">
            <a href="https://www.linkedin.com/company/ask-eko" target="_blank" rel="noopener noreferrer" aria-label="LinkedIn">LinkedIn</a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
